import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import { Store } from '@ngrx/store';
import swal from 'sweetalert2';
import { AddEditDoctorUserComponent } from './addEditDoctorUser.component';

import { UserModel } from '../../../model/index';
import { UserService } from '../../../services/index';

@Component({
    selector: 'doctor-user-tab',
    templateUrl: './doctorUserList.component.html',
})
export class DoctorUserMasterComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    public mode: string;
    public list: any[] = [];
    public branchdata: any[] = [];

    isLoadMask: Promise<any>;
    branchData: UserModel[];
    isLoading: boolean = false;
    filterData = {
        "search_data": ""
    };

    constructor(private userService: UserService, private modalService: BsModalService) { }

    loadingIndicator: boolean = true;
    reorderable: boolean = true;

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'username',
        orderDir: 'asc'
    };

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;

    columns = [];
    scrollTimeout: any;
    suppressPaging: boolean = false;
    ngOnInit(): void {
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, cellClass: 'cell-center', sortable: false, cellTemplate: this.snoTemplate },
            { name: 'User Name', prop: 'username', width: 150, minWidth: 150, maxWidth: 150 },
            { name: 'Full Name', prop: 'fullname', width: 170, minWidth: 170, maxWidth: 170 },
            { name: 'Address', prop: 'address', width: 300, minWidth: 300, maxWidth: 300 },
            { name: 'Mobile', prop: 'mobile', width: 140, minWidth: 140, maxWidth: 140 },
            { name: 'Branch', prop: 'branch_name', width: 140, minWidth: 140, maxWidth: 140 },
            { name: 'Doctor Name', prop: 'doctorname', width: 170, minWidth: 170, maxWidth: 170 },
            { name: 'Doctor Assistant', prop: 'doctor_assistant', width: 140, minWidth: 140, maxWidth: 140 },
            { name: 'Status', prop: 'status', width: 140, minWidth: 140, maxWidth: 140 },
            { name: 'Action', prop: 'sno', width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
        ];

        this.pageCallback({ offset: 0 });
    }

    /**
    * Called whenever the user changes page
    */
    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        if (this.suppressPaging) { return; }
        this.page.offset = pageInfo.offset;
        this.getDoctorUserList();
    }

    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) {
            clearTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 100)
    }

    onOpenedFilter(): void {
        setTimeout(function() {
            $('#filterSearch').focus();
        }, 100);
    }

    clearFilter(): void {
        this.filterData = { "search_data": "" };
        this.applyFilter();
    }

    applyFilter(): void {
        this.filterPanel.close();
        this.getDoctorUserList();
    }

    getDoctorUserList(): void {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            filter: JSON.stringify(this.filterData)
        };
        let that = this;
        this.isLoadMask = this.userService
            .getDoctorUserList(params)
            .then(function(res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.branchData = res.data;
            });
    }
    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getDoctorUserList();
    }

    bsModalRef: BsModalRef;
    public onAddEditDoctorUser(mode: string, row: any): void {
        let that = this;
        this.bsModalRef = this.modalService.show(AddEditDoctorUserComponent, {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-lg maxWidthPer-70'
        });
        row['mode'] = mode;
        this.bsModalRef.content.title = mode + ' Doctor User Details';

        this.bsModalRef.content.userdata = Object.assign({}, row);
        this.bsModalRef.content.userListLoadEvent.subscribe(($e) => {
            that.getDoctorUserList();
        });
    }

}


// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/doctorUserMaster/doctorUserList.component.ts